export function copyTextToClipBoard (text) {
  let error = null

  if (navigator.clipboard) {
    try {
      navigator.clipboard.writeText(text)
    } catch (e) {
      error = e
    }
  } else {
    const textarea = document.createElement('textarea')
    textarea.value = text

    textarea.style.top = '0'
    textarea.style.left = '0'
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'

    document.body.appendChild(textarea)

    textarea.focus()
    textarea.select()

    try {
      document.execCommand('copy')
    } catch (e) {
      error = e
    }

    document.body.removeChild(textarea)
  }

  return error
}

/**
 * @property customText {Object<{
 *   error: {
 *     title: String,
 *     text: String,
 *   },
 *   success: {
 *     title: String,
 *     text: String,
 *   },
 * }>}
 */
export function copyToast (toast, copyText, customText = {}) {
  const copyError = copyTextToClipBoard(copyText)

  const toastContent = {
    title: '',
    text: ''
  }

  if (copyError) {
    toastContent.title = (customText.error && customText.error.title) || 'Ошибка'
    toastContent.text = (customText.error && customText.error.text) || ('Произошла ошибка при копировании')
  } else {
    toastContent.title = (customText.success && customText.success.title) || 'Успех'
    toastContent.text = (customText.success && customText.success.text) || `'${copyText}' успешно скопировано в буфер обмена`
  }

  toast(toastContent.text, { title: toastContent.title, duration: 3000 })
}
